import React from "react";
import "./home.css";
import girl from "../../image/girl.svg";
import { BsCalendar2Check } from "react-icons/bs";
import { GoLocation } from "react-icons//go";

const Notice = () => {
  return (
    <div className="h-full bg-white shadow-[0px_4px_24px_0px_rgba(34,41,47,10%)] rounded-md  max-h-96 overflow-y-scroll">
      <div>
        <div className=" bg-[#EEEDFD] flex justify-center">
          <img className=" max-h-36" src={girl} alt="girl" />
        </div>

        <div className="mt-4 px-5">
          <div className="flex  ">
            <div className="  flex flex-col pr-2 border-r ">
              <span className=" text-center font-medium text-[#5e5873]">
                THU
              </span>
              <span className=" text-center font-semibold text-lg text-[#5e5873]">
                24
              </span>
            </div>

            <div className="ml-2">
              <h1 className=" text-xl font-medium text-[#5e5873]">
                Developer Meetup
              </h1>
              <p className=" text-sm text-[#5e5873]">
                Meet world popular developers
              </p>
            </div>
          </div>
          <div className="mt-5">
            <div className=" flex items-center ">
              <BsCalendar2Check className="text-3xl text-[#8f87ff] mr-2" />
              <div className="ml-2">
                <p className="text-[#5e5873] ml-3 font-medium">
                  Sat, May 25, 2020
                </p>
                <p className="text-[#5e5873] ml-3 text-sm">10:AM to 6:PM</p>
              </div>
            </div>
            <div className=" flex mt-3 items-center ">
              <GoLocation className="text-3xl text-[#8f87ff] mr-2" />

              <div className=" ml-2">
                <p className="text-[#5e5873] ml-3 font-medium">
                  East Delta University
                </p>
                <p className="text-[#5e5873] ml-3 text-sm">
                  Abdullah Al Noman Road, Noman Society
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notice;
